module.exports = __webpack_public_path__ + "static/media/main.cb99a2a0.wav";